import React from "react";

const MenuContext = React.createContext(null);

export default MenuContext;
